import React, { useState, useEffect } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import { getFilterInfoPage, getFilterInfoPageName, getLanguageName, getTVMenuName } from '../utils'
import SelectBoxFilter from '../common/select-box-filter'

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: 30,
        borderTopColor: '#f3f7fa'
    },
    selectBoxContainer: {
        width: 600,
        marginTop: theme.spacing(3.5)
    }
}));

function LinkedMenu(props) {
    const classes = useStyles();
    const translate = useTranslate();
    const dispatch = useDispatch();
    const dataProvider = useDataProvider();

    // STATE
    const [languages, setLanguages] = useState([]);
    const [menus, setMenus] = useState([]);
    const [selectMenu, setSelectMenu] = useState(-1);
    // END STATE

    const { isEditing, nodeSelected, infoPages, selectedInfoPage } = useSelector(state => state.tree);
    const { applicationData, nodelevel } = nodeSelected;
    const { nodeLinkedMenu } = applicationData;
    const { infoPageId, infoPageLanguageId, tvMenuId } = nodeLinkedMenu;

    useEffect(() => {
        if (selectMenu !== -1)
            setLinkMenuPreview(selectMenu);
    }, [nodeSelected, selectMenu])

    const onChangeValue = (array = []) => {
        const linkedMenu = { ...nodeLinkedMenu };
        for (let i = 0; i < array.length; i++) {
            const { key, value } = array[i];
            linkedMenu[key] = value;
        }

        const newNode = {
            ...nodeSelected.applicationData,
            nodeLinkedMenu: linkedMenu
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const onChangeLinkedInfoPage = (infoPage) => {
        if (infoPage && infoPage.id !== infoPageId) {
            onChangeValue([
                { key: 'infoPageId', value: infoPage.id },
                { key: 'infoPageLanguageId', value: null },
                { key: 'tvMenuId', value: null },
            ]);
        }
    }

    const onChangeLanguage = (lang) => {
        onChangeValue([
            { key: 'infoPageLanguageId', value: lang.infoPageLanguageId },
            { key: 'tvMenuId', value: null },
        ]);
    }

    const getListTVMenu = () => {
        dataProvider('GET_LIST', 'tvmenu/find-tvmenu-as-same-level', {
            sort: { field: 'createdAt', order: 'DESC' },
            pagination: { page: 1, perPage: 100 },
            filter: {
                infoPageLanguageId,
                nodelevel,
                id: nodeSelected.id
            }
        }).then(({ data }) => {
            setMenus(data);
            const selectMenu = data.find(m => m.id === tvMenuId);
            setSelectMenu(data.indexOf(selectMenu));
        }).catch(error => console.log('GET LIST LANG ERROR:', error));
    }

    const getListLanguage = () => {
        dataProvider('GET_LIST', 'info-language/find-info-page-languages', {
            sort: { field: 'createdAt', order: 'DESC' },
            pagination: { page: 1, perPage: 100 },
            filter: { infopage: infoPageId }
        }).then(({ data }) => {
            setLanguages(data);
        }).catch(error => console.log('GET LIST LANG ERROR:', error));
    }

    const onChangeNodeMenu = (menu) => {
        onChangeValue([{ key: 'tvMenuId', value: menu.id }]);
        setSelectMenu(menus.indexOf(menu));
        // setLinkMenuPreview(menus.indexOf(menu));
    }

    const setLinkMenuPreview = (idx) => {
        if (idx !== -1 && menus && menus.length > idx) {
            const menu = menus[idx];
            try {
                menu.applicationData = JSON.parse(menu.applicationData);
                if (props.setCurrentNodeLinkMenuFunc)
                    props.setCurrentNodeLinkMenuFunc(menu);
            }
            catch { }
        }
    }

    useEffect(() => {
        getListLanguage();
    }, [infoPageId]);

    useEffect(() => {
        getListTVMenu();
    }, [infoPageLanguageId]);

    return (
        <Box className={classes.container}>
            <Box className={classes.selectBoxContainer}>
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={getFilterInfoPage(infoPages, selectedInfoPage.id)}
                    label={translate('resources.infoPage.linked_menu.select_info_page')}
                    value={getFilterInfoPageName(infoPages, infoPageId)}
                    onChange={(value) => onChangeLinkedInfoPage(value)}
                    keyName='name'
                    placeholder={translate('resources.infoPage.filter_select_info_page')}
                />
            </Box>
            <Box className={classes.selectBoxContainer}>
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={languages}
                    label={translate('resources.infoPage.linked_menu.select_language')}
                    value={getLanguageName(languages, infoPageLanguageId)}
                    onChange={(value) => onChangeLanguage(value)}
                    keyName='name'
                    placeholder={translate('resources.infoPage.filter_select_language')}
                />
            </Box>
            <Box className={classes.selectBoxContainer}>
                <SelectBoxFilter
                    disabled={!isEditing}
                    data={menus}
                    label={translate('resources.infoPage.linked_menu.select_tv_menu')}
                    value={getTVMenuName(menus, tvMenuId)}
                    onChange={(value) => onChangeNodeMenu(value)}
                    keyName='nodeName'
                    placeholder={translate('resources.infoPage.filter_select_tv_menu')}
                />
            </Box>
        </Box>
    )
}

export default LinkedMenu;
